import { createContext, useContext, useEffect, useState } from "react";
import api from "./api";

const Ctx = createContext(null);

export const useAdminAuth = () => useContext(Ctx);

export const AdminAuthProvider = ({ children }) => {
    const [user, setUser] = useState(undefined); // undefined = checking, null = guest

    useEffect(() => {
        api.get("/api/auth/me")
            .then((r) => setUser(r.data))
            .catch(() => setUser(null));
    }, []);

    const logout = async () => {
        try {
            await api.post("/api/auth/logout");
        } catch {
            /* ignore */
        }
        setUser(null);
    };

    return <Ctx.Provider value={{ user, setUser, logout }}>{children}</Ctx.Provider>;
};
